export const INITIAL_STYLE_URL = 'mapbox://styles/planetwatchsas/cli906i5t02uh01pg7sqg4cjc'
export const ALTERNATIVE_STYLE_URL = 'mapbox://styles/planetwatchsas/cliw2pu4r004701pb49hf2tm8'
export const ALTERNATIVE_STYLE_URL_LIGHT = 'mapbox://styles/planetwatchsas/clj51fvsb000u01qx5werhx32'
export const INITIAL_STYLE_URL_LIGHT = 'mapbox://styles/planetwatchsas/clj51jtum000h01p9hrlpbpze'
